<template>
  <div id="pwcList" v-if="pwcList.length > 0">
    <ul>
      <li v-for="item in pwcList" :key="item.id">
        <p>{{ item.activityPaperName }}</p>
        <span>开始时间：{{ getTimestampToTime(item.startTime) }}</span>
        <span>结束时间：{{ getTimestampToTime(item.endTime) }}</span>
        <a :href="item.activityUrl">开始考试</a>
      </li>
    </ul>
  </div>
</template>

<script>
import {getExamConfigListByCwareIDApi} from '@api/activity'
import {timestampToTime} from "@/utils"

export default {
  //member.chinaacc.com/qzSim/mid/#/activity/pwc/pwcList?cwareID=49624
  name: "pwcList",
  data() {
    return {
      pwcList: []
    }
  },
  async mounted() {
    await this.getExamConfigListByCwareID()
  },
  methods: {
    getExamConfigListByCwareID() {
      getExamConfigListByCwareIDApi({cwareID: parseInt(this.$route.query.cwareID)}).then(res => {
        this.pwcList = res || []
      })
    },
    getTimestampToTime(time) {
      return timestampToTime(time)
    }
  }
}
</script>

<style lang="scss">
#pwcList {
  position: absolute;
  left: 50%;
  top: 20px;
  margin-left: -400px;
  border-radius: 8px;
  width: 800px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .2);
  //transform: translateY(-50%);
  background: #fff;

  ul {
    padding: 20px 30px;

    li {
      position: relative;
      z-index: 1;
      padding: 12px 0;
      border-bottom: 1px solid #eee;

      p {
        line-height: 24px;
        font-size: 18px;
        margin-bottom: 8px;
        margin-right: 124px;
      }

      span {
        font-size: 14px;
        color: #999;

        & + span {
          margin-left: 12px;
        }
      }

      a {
        padding: 0 18px;
        line-height: 32px;
        position: absolute;
        right: 0;
        top: 12px;
        background: #07bdc7;
        font-size: 14px;
        border-radius: 100px;
        color: #fff;

        &:hover {
          opacity: .9;
        }
      }

      &:last-child {
        border-bottom: 0 none;
      }
    }

  }
}
</style>
